<template>
    <div id="footer">
        <div
            class="kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop"
            id="kt_footer" style="border-top: 0.5px solid #f9f9f9;"
          >
            <div class="kt-footer__copyright">
              2019&nbsp;&copy;&nbsp;
              <a href="/" class="kt-link">Hapos Developer V. {{ convert_vs(vss.toString()) }}</a>
            </div>
            <div class="kt-footer__menu" style="font-size: 13px;">
              <img :src="$store.state.config.logo" width="30" height="20">&nbsp;
              {{ $store.state.config.name }}
            </div>
          </div>
    </div>
</template>

<script>
import VS from '../../../static/version.json'
export default {
  data () {
    return {
      vss: VS.version
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/footer.vue